import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_blue_header/reservation-confirmation/$reservationId')({
  beforeLoad: ({ params }) => {
    throw redirect({ params, replace: true, to: '/confirmation-reservation/$reservationId' })
  },
})
